import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
    listenToMessage,
    ReceivedMessageType,
    sendMessage,
    SendMessageType,
} from '@om-fe/core/utils/parent-communication';
import { BemMethod, createBem } from '@om-fe/utils';
import { useHistory } from 'react-router-dom';
import { History } from 'history';
import { BetslipWrapperDesktop } from './betslip-wrapper-desktop';
import { BetslipOpenBetsTabs } from './betslip-tabs';
import { PanicButton } from '@om-fe/core/components/panic-button/panic-button';
import getConfig from '@om-fe/core/utils/config';

const betslipWrapperBem: BemMethod = createBem('BetslipWrapper');
const betslipOverlayBem: BemMethod = createBem('BetslipOverlay');
const panicButtonEnabled: boolean | undefined = getConfig()?.panicButton?.enabled;

export function BetslipWrapperMobile() {
    const [selectedTab, setSelectedTab] = useState<BetslipOpenBetsTabs | undefined>();
    const history: History = useHistory();
    const handleSelectTab = useCallback((tab?: BetslipOpenBetsTabs) => {
        setSelectedTab(tab);

        if (!tab) {
            sendMessage({ type: 'OMFE:hideBetslip' as SendMessageType });
            sendMessage({ type: 'OMFE:hideBetslip' as SendMessageType, isInternal: true });
        } else {
            sendMessage({ type: 'OMFE:showBetslip' as SendMessageType });
        }
    }, []);
    useEffect(() => {
        return history.listen(() => handleSelectTab(undefined));
    }, [handleSelectTab, history]);

    const handleOpenModal = useCallback(() => {
        handleSelectTab(BetslipOpenBetsTabs.BetSlip);
    }, [handleSelectTab]);

    useEffect(() => {
        const showBetslipUnsubscribe = listenToMessage('OP:showBetslip' as ReceivedMessageType, () => {
            handleSelectTab(BetslipOpenBetsTabs.BetSlip);
        });

        const hideBetslipUnsubscribe = listenToMessage('OP:hideBetslip' as ReceivedMessageType, () => {
            handleSelectTab(undefined);
        });

        const showOpenBetsUnsubscribe = listenToMessage('OP:showOpenBets' as ReceivedMessageType, () => {
            handleSelectTab(BetslipOpenBetsTabs.OpenBets);
        });

        return () => {
            showBetslipUnsubscribe();
            showOpenBetsUnsubscribe();
            hideBetslipUnsubscribe();
        };
    }, [handleSelectTab, selectedTab]);

    const handleCloseModal = useCallback(() => {
        handleSelectTab(undefined);
    }, [handleSelectTab]);
    const parentContainerRef = useRef();

    return (
        <>
            <div
                onClick={handleCloseModal}
                className={betslipOverlayBem({ modifiers: { IsOverlayOpen: !!selectedTab } })}
            />
            <div
                className={betslipWrapperBem({
                    modifiers: {
                        IsBetslipOpen: !!selectedTab,
                        IsPanicButtonEnabled: !!(panicButtonEnabled && selectedTab)
                    },
                })}
                ref={parentContainerRef}
            >
                {!!(panicButtonEnabled && selectedTab) && ( <PanicButton deviceType="mobile" /> )}
                <BetslipWrapperDesktop
                    onTabChanged={handleSelectTab}
                    openModal={handleOpenModal}
                    closeModal={handleCloseModal}
                />
            </div>
        </>
    );
}
